'use es6';

export const getPageSize = state => state.pageSize.get('pageSize');